import { datadogRum } from '@datadog/browser-rum'
import { UserDataService } from './UserDataService'

function setUserData() {
  const userData = UserDataService.getUserData()
  if (userData && userData.nombre) {
    datadogRum.setUser({
      name: userData.nombre,
      email: userData.email
    })
  }
}

export const DatadogService = {
  start: () => {
    const isProduction = import.meta.env.PROD
    if (isProduction) {
      if (!datadogRum.getInternalContext()) {
        datadogRum.init({
          applicationId: 'c79fbdcb-71e1-43bc-b02c-19d3734e9396',
          clientToken: 'pube24be5dcc08011bb19c2ee979d9e489c',
          site: 'datadoghq.eu',
          service: 'weather-map',
          env: 'prod',
          version: import.meta.env.VITE_CI_COMMIT_TAG,
          proxy: `${window.location.protocol}//${window.location.hostname}/dd-proxy`,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 100,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input',
          enableExperimentalFeatures: ['clickmap', 'feature_flags'],
          allowedTracingUrls: ['https://api.weathermap.site']
        })
        datadogRum.startSessionReplayRecording()
      }
      setUserData()
    }
  },

  setUserData: () => {
    setUserData()
  }
}
